import { MODULE_PATH_NAMES } from 'mini-module-switcher/lib/utils/onModuleSwitcherItemClick';
import { Module } from 'mini-module-switcher';
import { AppName, ServerAppName } from 'data/lib/mini-app-constants';
type getPathMetadataReturnType = {
    isCalendar: boolean;
    isTodo: boolean;
    isPeople: boolean;
    isMail: boolean;
    moduleEnum: Module;
    appName: AppName;
    serverAppName: ServerAppName;
};
export const getPathMetadata = (): getPathMetadataReturnType => {
    const pathname = location.pathname;
    let appName = AppName.MINI_DEEP_OPX;
    const module = Object.entries(MODULE_PATH_NAMES).find(([, path]) =>
        pathname.includes(`opxdeeplink${path}`)
    )?.[0];
    let isCalendar, isTodo, isPeople, isMail, moduleEnum, serverAppName;
    if (Module.Calendar.toString() === module) {
        isCalendar = true;
        moduleEnum = Module.Calendar;
        appName = AppName.CALENDAR;
        serverAppName = ServerAppName.MiniCalendar;
    } else if (Module.ToDo.toString() === module) {
        isTodo = true;
        moduleEnum = Module.ToDo;
        appName = AppName.TODO;
        serverAppName = ServerAppName.MiniPeople;
    } else if (Module.People.toString() === module) {
        isPeople = true;
        moduleEnum = Module.People;
        appName = AppName.PEOPLE;
        serverAppName = ServerAppName.MiniPeople;
    } else if (Module.Mail.toString() === module) {
        isMail = true;
        moduleEnum = Module.Mail;
        appName = AppName.MAIL;
        serverAppName = ServerAppName.Mini;
    }
    return { isCalendar, isTodo, isPeople, isMail, moduleEnum, appName, serverAppName };
};
